import { StyleSheet } from 'react-native';
import { DynamicStyleSheet } from '@pulsar/core';
import { Platform } from 'src/libs/platform';

export default DynamicStyleSheet.create(theme => ({
  root: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 44,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: theme.colors.formFieldBorder,
    backgroundColor: theme.colors.formFieldBG,
    ...Platform.select({
      ios: {
        borderRadius: theme.radii.ios,
      },
      android: {
        borderRadius: theme.radii.android,
      },
      default: {
        borderRadius: theme.radii.web,
      },
    }),
    overflow: 'hidden',
  },
  error: {
    backgroundColor: theme.colors.formFieldErrorBG,
    borderColor: theme.colors.formFieldErrorBorder,
  },
  hovered: {
    borderColor: theme.colors.formFieldHoveredBorder,
  },
  focused: {
    borderColor: theme.colors.formFieldFocusedBorder,
  },
  disabled: {
    opacity: 0.6,
  },
  success: {
    borderColor: theme.colors.formFieldSuccessBorder,
  },
  input: {
    width: '100%',
    paddingVertical: 12,
    padding: 12,
    fontSize: theme.fontSizes[2],
    color: theme.colors.textDefault,
  },
  icon: {
    position: 'absolute',
    left: 12,
    color: theme.colors.formFieldIcon,
  },
  iconActive: {
    color: theme.colors.formFieldIconActive,
  },
  withIcon: {
    paddingLeft: 12 + 24 + 8,
  },
}));
